import { createContext } from "react";
import type { FuseFlatNavItemType } from "@fuse/core/FuseNavigation/types/FuseNavItemType";

// Define the context type
export type NavigationContextType = {
	navigationItems: FuseFlatNavItemType[];
};

// Create the context
export const NavigationContext = createContext<NavigationContextType | undefined>(undefined);
